export default {
  HOST: "https://yavienenlosreyesmagos.com",
  START_DATE: new Date(2021, 0, 5, 18, 0, 0),
  MAX_DATE: new Date(2021, 0, 7, 0, 0, 0),
  PAGINATION: 20,
};
